const FJFaceSwapData = {
    THOSE_ORIGIN_IMAGES: [
        {
            name: 'origin-10',
        },
        {
            name: 'origin-11',
        },
        {
            name: 'origin-6',
        },
        {
            name: 'origin-9',
        },
        {
            name: 'origin-19',
        },
        {
            name: 'origin-20',
        },
        {
            name: 'origin-17',
        },
        {
            name: 'origin-18',
        },
        {
            name: 'origin-4',
        },
        {
            name: 'origin-2',
        },
        {
            name: 'origin-12',
        },
        {
            name: 'origin-1',
        },
        {
            name: 'origin-7',
        },
        {
            name: 'origin-8',
        },
        {
            name: 'origin-3',
        },
        {
            name: 'origin-5',
        },
    ],
    THOSE_TARGET_IMAGES: [
        {
            name: 'target-1',
        },
        {
            name: 'target-2',
        },
        {
            name: 'target-3',
        },
        {
            name: 'target-4',
        },
    ],
};

export default FJFaceSwapData;
